export const shopfloorMessages = {
  en: {
    shopfloor: {
      appTitle: 'Shopfloor',
      appDescription: 'Shift execution, worker and machine assignments, output, downtime, and handover.',
      nav: {
        shiftDashboard: 'Shift dashboard',
        activeOrders: 'Active orders',
        assignments: 'Assignments',
        hourlyOutput: 'Hourly output',
        downtime: 'Downtime',
        handover: 'Handover',
        help: 'Help',
      },
      help: {
        eyebrow: 'Help center',
        title: 'Help',
        subtitle: 'Step-by-step guides for every section.',
        back: 'Back to help',
        notFound: 'Article not found.',
        tipsTitle: 'Tips',
      },
      dashboard: {
        eyebrow: 'Manufacturing execution',
        title: 'Shift dashboard',
        description: 'Active production status, bottlenecks, and shift summary.',
        activeOrders: 'Active orders',
        ordersCount: '{count} orders',
        planVsActual: 'Plan vs actual',
        planned: 'Planned',
        produced: 'Produced',
        pairs: '{count} pairs',
        bottlenecks: 'Bottlenecks',
        noBottlenecks: 'No bottlenecks detected.',
        bottleneckHint: 'Select a bottleneck to open the order and inspect the blocked stage.',
        stageBlocked: '{stage} blocked',
        employeeSummary: 'Employee summary',
        assigned: '{count} assigned',
        machineSummary: 'Machine summary',
        running: '{count} running',
        idle: '{count} idle',
        loading: 'Loading shift data…',
        error: 'Failed to load shift data.',
        retry: 'Retry',
        completion: 'Completion',
        rejectsRework: 'Rejects & rework',
        rejectedPairs: '{count} rejected pairs · {rework} rework',
        employeeAssignment: 'Employee assignment',
        employeesAssigned: '{count} employees assigned to open stages',
      },
      orders: {
        eyebrow: 'Production orders',
        title: 'Active orders',
        description: 'Production orders currently in execution.',
        search: 'Search orders',
        searchPlaceholder: 'Order code, product, or department',
        status: 'Status',
        allStatuses: 'All statuses',
        inProgress: 'In progress',
        completed: 'Completed',
        pending: 'Pending',
        statuses: {
          planned: 'Planned',
          in_progress: 'In progress',
          completed: 'Completed',
          cancelled: 'Cancelled',
        },
        code: 'Order',
        product: 'Product',
        department: 'Department',
        plannedQty: 'Planned',
        producedQty: 'Produced',
        progress: 'Progress',
        stage: 'Stage',
        actions: 'Actions',
        loading: 'Loading orders…',
        empty: 'No production orders match the selected filters.',
        viewLots: 'View lots',
      },
      assignments: {
        eyebrow: 'Resource assignments',
        title: 'Employee & machine assignments',
        description: 'Current shift assignments for employees and machines.',
        employeeTab: 'Employees',
        machineTab: 'Machines',
        employee: 'Employee',
        machine: 'Machine',
        operation: 'Operation',
        order: 'Order',
        lot: 'Lot',
        assignedAt: 'Assigned at',
        status: 'Status',
        active: 'Active',
        loading: 'Loading assignments…',
        empty: 'No active assignments for the current shift.',
        unassigned: 'Unassigned',
        createAssignment: 'Create assignment',
        create: 'Create',
        creating: 'Creating…',
        end: 'End',
        endConfirm: 'End this assignment?',
        allShifts: 'All shifts',
        shift: 'Shift',
        day: 'Day',
        night: 'Night',
        type: 'Type',
        orderId: 'Order ID',
        stageCode: 'Stage code',
        stage: 'Stage',
        selectStage: 'Select stage',
        selectEmployee: 'Select employee',
        selectMachine: 'Select machine',
        noLot: 'No lot',
        cancel: 'Cancel',
        save: 'Save',
        ended: 'Ended',
        noEnded: 'Show active only',
      },
      output: {
        eyebrow: 'Production tracking',
        title: 'Daily output',
        description: 'Production counts by stage and employee for the selected date.',
        date: 'Date',
        stage: 'Stage',
        stageCode: 'Stage code',
        employee: 'Employee',
        allStages: 'All stages',
        allEmployees: 'All employees',
        completed: 'Completed',
        rejected: 'Rejected',
        rework: 'Rework',
        unassigned: 'Unassigned',
        exportCsv: 'Export CSV',
        loading: 'Loading output data…',
        empty: 'No output data recorded for this date.',
        retry: 'Retry',
      },
      orderDetail: {
        backToOrders: 'Back to orders',
        title: 'Production order',
        planned: 'Planned',
        produced: 'Produced',
        totalLots: 'Total lots',
        activeLots: 'Active lots',
        completedLots: 'Completed lots',
        stageProgress: 'Stage progress',
        cancel: 'Cancel',
        createLot: 'Create lot',
        creating: 'Creating…',
        startingStage: 'Starting stage',
        quantity: 'Quantity',
        notes: 'Notes',
        colorVariants: 'Color variants',
        addColor: 'Add color',
        removeColor: 'Remove',
        colorName: 'Color',
        colorQuantity: 'Qty',
        colorSummary: 'Colors',
        colorsSumHint: 'Sum {sum} of {quantity}',
        colorRequired: 'Enter a color name and a positive quantity for every row.',
        colorSumError: 'Color quantities must equal the lot quantity.',
        lotCreated: 'Lot {lot} created.',
        noStages: 'No stages configured for this order.',
        lotQueue: 'Lot queue',
        lotNumber: 'Lot number',
        allStatuses: 'All statuses',
        allStages: 'All stages',
        active: 'Active',
        completed: 'Completed',
        cancelled: 'Cancelled',
        lotStatuses: {
          active: 'Active',
          completed: 'Completed',
          cancelled: 'Cancelled',
        },
        stageStatuses: {
          pending: 'Pending',
          in_progress: 'In progress',
          closed: 'Closed',
          completed: 'Completed',
        },
        noLotsMatch: 'No lots match the selected filters.',
        lot: 'Lot',
        status: 'Status',
        currentStage: 'Current stage',
        initial: 'Initial',
        current: 'Current',
        created: 'Created',
        actions: 'Actions',
        progress: 'Progress',
        closeStage: 'Close stage',
        recordProgress: 'Record progress',
        stageLabel: 'Stage:',
        completedQty: 'Completed',
        rejected: 'Rejected',
        rework: 'Rework',
        employeeId: 'Employee ID',
        employee: 'Employee',
        unassigned: 'Unassigned',
        selectEmployeePlaceholder: 'Select employee',
        details: 'Details',
        viewEntries: 'Entries',
        reopenStage: 'Reopen',
        closeStageTitle: 'Close stage',
        closeStageHint: 'Closes this stage for the whole order (all lots).',
        confirm: 'Confirm',
        close: 'Close',
        reopenStageTitle: 'Reopen stage',
        reopenHint: 'Reopening requires a reason and supervisor permission.',
        reopenReason: 'Reason',
        selectReason: 'Select reason…',
        reopenReasonText: 'Reason details',
        reopenRequiresReason: 'Select a reason and enter details.',
        stageClosedAll: 'Stage {stage} closed for all lots.',
        stageReopened: 'Stage {stage} reopened.',
        entriesTitle: 'Stage entries',
        noEntries: 'No entries recorded for this stage.',
        entryAction: 'Action',
        entryDeltas: 'Deltas',
        entryEmployee: 'Employee',
        entryLot: 'Lot',
        entryTime: 'Time',
        entryStage: 'Stage',
        entryTypes: {
          progress: 'Progress',
          close: 'Close',
          reopen: 'Reopen',
          create: 'Create',
        },
        reopenReasons: {
          qc_issue: 'QC issue',
          operator_error: 'Operator error',
          material_issue: 'Material issue',
          machine_issue: 'Machine issue',
          supervisor_decision: 'Supervisor decision',
          other: 'Other',
        },
        lotDetailsTitle: 'Lot details',
        lotStages: 'Lot stage tracking',
        lotEntries: 'Lot activity',
        stage: 'Stage',
        save: 'Save',
        selectEmployee: 'Select the reporting employee.',
        selectClosingEmployee: 'Select the closing employee.',
        closeConfirm: 'Close stage {stage} for lot {lot}?',
        progressRecorded: 'Progress recorded for lot {lot}.',
        stageClosed: 'Stage closed for lot {lot}.',
        enterStageQuantity: 'Enter a starting stage and a quantity greater than zero.',
        loadingOrder: 'Loading order…',
        pageOf: 'Page {page} of {total}',
        previous: 'Previous',
        next: 'Next',
      },
      downtime: {
        eyebrow: 'Downtime tracking',
        title: 'Downtime events',
        description: 'Recorded downtime with reasons and durations.',
        reason: 'Reason',
        machine: 'Machine',
        noMachine: 'No machine',
        selectMachine: 'Select machine…',
        reasons: {
          machine_breakdown: 'Machine breakdown',
          setup_change: 'Setup / size change',
          yarn_shortage: 'Yarn shortage',
          power_outage: 'Power outage',
          no_assignment: 'No operator assigned',
          qc_wait: 'Waiting for QC',
        },
        start: 'Start',
        end: 'End',
        duration: 'Duration',
        minutes: '{count} min',
        reportedBy: 'Reported by',
        loading: 'Loading downtime events…',
        empty: 'No downtime events recorded.',
        totalDowntime: 'Total downtime',
        activeDowntime: 'Active downtime',
        noActiveDowntime: 'No active downtime events.',
        ongoing: 'Ongoing',
        openDowntime: 'Report downtime',
        close: 'Close',
        closeConfirm: 'Close this downtime event?',
        selectReason: 'Select reason',
        machineId: 'Machine ID',
        startTime: 'Start time',
        endTime: 'End time',
        report: 'Report',
        reporting: 'Reporting…',
        openOnly: 'Open only',
        reported: 'Reported downtime #{id}',
        closed: 'Downtime #{id} closed',
      },
      handover: {
        eyebrow: 'Shift management',
        title: 'Shift handover',
        description: 'Shift handover records and supervisor notes.',
        shift: 'Shift',
        from: 'From',
        to: 'To',
        supervisor: 'Supervisor',
        notes: 'Notes',
        summary: 'Summary',
        ordersHandedOver: 'Orders handed over',
        issuesFlagged: 'Issues flagged',
        loading: 'Loading handover records…',
        empty: 'No handover records for the selected period.',
        attentionRequired: 'Attention required',
        printSnapshot: 'Print snapshot',
        exportCsv: 'Export CSV',
        createHandover: 'Create handover',
        create: 'Create',
        creating: 'Creating…',
        save: 'Save',
        cancel: 'Cancel',
        created: 'Handover #{id} created',
      },
      pagination: {
        of: 'of',
        previous: 'Previous',
        next: 'Next',
      },
      state: {
        loading: 'Loading…',
        error: 'Something went wrong.',
        retry: 'Retry',
        noData: 'No data available.',
      },
    },
  },
  uz: {
    shopfloor: {
      appTitle: 'Ishlab chiqarish maydoni',
      appDescription: 'Smena boshqaruvi, ishchi va mashina taqsimoti, ishlab chiqarish, to‘xtalishlar va smena topshirish.',
      nav: {
        shiftDashboard: 'Smena paneli',
        activeOrders: 'Faol buyurtmalar',
        assignments: 'Taqsimotlar',
        hourlyOutput: 'Soatlik ishlab chiqarish',
        downtime: 'To‘xtalishlar',
        handover: 'Smena topshirish',
        help: 'Yordam',
      },
      help: {
        eyebrow: 'Yordam markazi',
        title: 'Yordam',
        subtitle: 'Har bir bo‘lim uchun bosqichma-bosqich qo‘llanmalar.',
        back: 'Yordamga qaytish',
        notFound: 'Maqola topilmadi.',
        tipsTitle: 'Maslahatlar',
      },
      dashboard: {
        eyebrow: 'Ishlab chiqarish boshqaruvi',
        title: 'Smena paneli',
        description: 'Faol ishlab chiqarish holati, muammolar va smena xulosasi.',
        activeOrders: 'Faol buyurtmalar',
        ordersCount: '{count} ta buyurtma',
        planVsActual: 'Reja va amal',
        planned: 'Reja',
        produced: 'Ishlab chiqarilgan',
        pairs: '{count} juft',
        bottlenecks: 'To‘siqlar',
        noBottlenecks: 'To‘siqlar aniqlanmadi.',
        bottleneckHint: 'To‘siqni tanlang — buyurtma ochilib, to‘silgan bosqich ko‘rsatiladi.',
        stageBlocked: '{stage} to‘sildi',
        employeeSummary: 'Xodimlar xulosasi',
        assigned: '{count} ta tayinlangan',
        machineSummary: 'Mashinalar xulosasi',
        running: '{count} ta ishlamoqda',
        idle: '{count} ta bo‘sh',
        loading: 'Smena ma’lumotlari yuklanmoqda…',
        error: 'Smena ma’lumotlarini yuklab bo‘lmadi.',
        retry: 'Qayta urinish',
        completion: 'Bajarilish',
        rejectsRework: 'Rad va qayta ishlash',
        rejectedPairs: '{count} rad etilgan juft · {rework} qayta ishlash',
        employeeAssignment: 'Xodimlar taqsimoti',
        employeesAssigned: '{count} ta xodim ochiq bosqichlarga tayinlangan',
      },
      orders: {
        eyebrow: 'Ishlab chiqarish buyurtmalari',
        title: 'Faol buyurtmalar',
        description: 'Hozirda bajarilayotgan ishlab chiqarish buyurtmalari.',
        search: 'Buyurtmalarni qidirish',
        searchPlaceholder: 'Buyurtma kodi, mahsulot yoki bo‘lim',
        status: 'Holat',
        allStatuses: 'Barcha holatlar',
        inProgress: 'Jarayonda',
        completed: 'Yakunlangan',
        pending: 'Kutilmoqda',
        statuses: {
          planned: 'Rejalashtirilgan',
          in_progress: 'Jarayonda',
          completed: 'Yakunlangan',
          cancelled: 'Bekor qilingan',
        },
        code: 'Buyurtma',
        product: 'Mahsulot',
        department: 'Bo‘lim',
        plannedQty: 'Reja',
        producedQty: 'Ishlab chiqarilgan',
        progress: 'Bajarilish',
        stage: 'Bosqich',
        actions: 'Amallar',
        loading: 'Buyurtmalar yuklanmoqda…',
        empty: 'Tanlangan filtrlarga mos buyurtmalar mavjud emas.',
        viewLots: 'Partiyalarni ko‘rish',
      },
      assignments: {
        eyebrow: 'Resurs taqsimoti',
        title: 'Xodim va mashina taqsimoti',
        description: 'Joriy smena uchun xodim va mashina taqsimotlari.',
        employeeTab: 'Xodimlar',
        machineTab: 'Mashinalar',
        employee: 'Xodim',
        machine: 'Mashina',
        operation: 'Operatsiya',
        order: 'Buyurtma',
        lot: 'Partiya',
        assignedAt: 'Tayinlangan vaqt',
        status: 'Holat',
        active: 'Faol',
        loading: 'Taqsimotlar yuklanmoqda…',
        empty: 'Joriy smena uchun faol taqsimotlar mavjud emas.',
        unassigned: 'Tayinlanmagan',
        createAssignment: 'Taqsimot yaratish',
        create: 'Yaratish',
        creating: 'Yaratilmoqda…',
        end: 'Yakunlash',
        endConfirm: 'Ushbu taqsimotni yakunlash kerakmi?',
        allShifts: 'Barcha smenalar',
        shift: 'Smena',
        day: 'Kunduzgi',
        night: 'Tungi',
        type: 'Tur',
        orderId: 'Buyurtma ID',
        stageCode: 'Bosqich kodi',
        stage: 'Bosqich',
        selectStage: 'Bosqichni tanlang',
        selectEmployee: 'Xodimni tanlang',
        selectMachine: 'Mashinani tanlang',
        noLot: 'Partiyasiz',
        cancel: 'Bekor qilish',
        save: 'Saqlash',
        ended: 'Yakunlangan',
        noEnded: 'Faqat faollari',
      },
      output: {
        eyebrow: 'Ishlab chiqarish kuzatuvi',
        title: 'Kunlik ishlab chiqarish',
        description: 'Tanlangan sana bo‘yicha bosqichlar va xodimlar kesimida ishlab chiqarish miqdorlari.',
        date: 'Sana',
        stage: 'Bosqich',
        stageCode: 'Bosqich kodi',
        employee: 'Xodim',
        allStages: 'Barcha bosqichlar',
        allEmployees: 'Barcha xodimlar',
        completed: 'Bajarilgan',
        rejected: 'Rad etilgan',
        rework: 'Qayta ishlash',
        unassigned: 'Tayinlanmagan',
        exportCsv: 'CSV eksport',
        loading: 'Ishlab chiqarish ma’lumotlari yuklanmoqda…',
        empty: 'Ushbu sana uchun ishlab chiqarish ma’lumotlari mavjud emas.',
        retry: 'Qayta urinish',
      },
      orderDetail: {
        backToOrders: 'Buyurtmalarga qaytish',
        title: 'Ishlab chiqarish buyurtmasi',
        planned: 'Reja',
        produced: 'Ishlab chiqarilgan',
        totalLots: 'Jami partiyalar',
        activeLots: 'Faol partiyalar',
        completedLots: 'Yakunlangan partiyalar',
        stageProgress: 'Bosqichlar bajarilishi',
        cancel: 'Bekor qilish',
        createLot: 'Partiya yaratish',
        creating: 'Yaratilmoqda…',
        startingStage: 'Boshlang‘ich bosqich',
        quantity: 'Miqdor',
        notes: 'Izohlar',
        colorVariants: 'Rang variantlari',
        addColor: 'Rang qo‘shish',
        removeColor: 'O‘chirish',
        colorName: 'Rang',
        colorQuantity: 'Soni',
        colorSummary: 'Ranglar',
        colorsSumHint: '{quantity} dan {sum} yig‘indi',
        colorRequired: 'Har bir qator uchun rang nomi va noldan katta son kiriting.',
        colorSumError: 'Ranglar soni partiya miqdoriga teng bo‘lishi kerak.',
        lotCreated: '{lot} partiyasi yaratildi.',
        noStages: 'Ushbu buyurtma uchun bosqichlar sozlanmagan.',
        lotQueue: 'Partiyalar navbati',
        lotNumber: 'Partiya raqami',
        allStatuses: 'Barcha holatlar',
        allStages: 'Barcha bosqichlar',
        active: 'Faol',
        completed: 'Yakunlangan',
        cancelled: 'Bekor qilingan',
        lotStatuses: {
          active: 'Faol',
          completed: 'Yakunlangan',
          cancelled: 'Bekor qilingan',
        },
        stageStatuses: {
          pending: 'Kutilmoqda',
          in_progress: 'Jarayonda',
          closed: 'Yopilgan',
          completed: 'Yakunlangan',
        },
        noLotsMatch: 'Tanlangan filtrlarga mos partiyalar mavjud emas.',
        lot: 'Partiya',
        status: 'Holat',
        currentStage: 'Joriy bosqich',
        initial: 'Boshlang‘ich',
        current: 'Joriy',
        created: 'Yaratilgan',
        actions: 'Amallar',
        progress: 'Bajarilish',
        closeStage: 'Bosqichni yopish',
        recordProgress: 'Bajarilishni qayd etish',
        stageLabel: 'Bosqich:',
        completedQty: 'Bajarilgan',
        rejected: 'Rad etilgan',
        rework: 'Qayta ishlash',
        employeeId: 'Xodim ID',
        employee: 'Xodim',
        unassigned: 'Tayinlanmagan',
        selectEmployeePlaceholder: 'Xodimni tanlang',
        details: 'Tafsilotlar',
        viewEntries: 'Yozuvlar',
        reopenStage: 'Qayta ochish',
        closeStageTitle: 'Bosqichni yopish',
        closeStageHint: 'Bu bosqich butun buyurtma bo‘yicha (barcha partiyalar) yopiladi.',
        confirm: 'Tasdiqlash',
        close: 'Yopish',
        reopenStageTitle: 'Bosqichni qayta ochish',
        reopenHint: 'Qayta ochish sabab va rahbar ruxsatini talab qiladi.',
        reopenReason: 'Sabab',
        selectReason: 'Sababni tanlang…',
        reopenReasonText: 'Sabab tafsiloti',
        reopenRequiresReason: 'Sababni tanlang va tafsilotni kiriting.',
        stageClosedAll: '{stage} bosqichi barcha partiyalar uchun yopildi.',
        stageReopened: '{stage} bosqichi qayta ochildi.',
        entriesTitle: 'Bosqich yozuvlari',
        noEntries: 'Ushbu bosqich uchun yozuvlar mavjud emas.',
        entryAction: 'Harakat',
        entryDeltas: 'O‘zgarishlar',
        entryEmployee: 'Xodim',
        entryLot: 'Partiya',
        entryTime: 'Vaqt',
        entryStage: 'Bosqich',
        entryTypes: {
          progress: 'Bajarilish',
          close: 'Yopish',
          reopen: 'Qayta ochish',
          create: 'Yaratish',
        },
        reopenReasons: {
          qc_issue: 'Sifat nazorati muammosi',
          operator_error: 'Operator xatosi',
          material_issue: 'Material muammosi',
          machine_issue: 'Mashina muammosi',
          supervisor_decision: 'Rahbar qarori',
          other: 'Boshqa',
        },
        lotDetailsTitle: 'Partiya tafsilotlari',
        lotStages: 'Partiya bosqichlari kuzatuvi',
        lotEntries: 'Partiya faoliyati',
        stage: 'Bosqich',
        save: 'Saqlash',
        selectEmployee: 'Hisobot beruvchi xodimni tanlang.',
        selectClosingEmployee: 'Yopuvchi xodimni tanlang.',
        closeConfirm: '{lot} partiyasi uchun {stage} bosqichini yopish kerakmi?',
        progressRecorded: '{lot} partiyasi uchun bajarilish qayd etildi.',
        stageClosed: '{lot} partiyasi uchun bosqich yopildi.',
        enterStageQuantity: 'Boshlang‘ich bosqich va noldan katta miqdorni kiriting.',
        loadingOrder: 'Buyurtma yuklanmoqda…',
        pageOf: '{total} dan {page}-sahifa',
        previous: 'Oldingi',
        next: 'Keyingi',
      },
      downtime: {
        eyebrow: 'To‘xtalishlar kuzatuvi',
        title: 'To‘xtalish hodisalari',
        description: 'Sabablari va davomiyligi bilan qayd etilgan to‘xtalishlar.',
        reason: 'Sabab',
        machine: 'Mashina',
        noMachine: 'Mashina yo‘q',
        selectMachine: 'Mashinani tanlang…',
        reasons: {
          machine_breakdown: 'Mashina buzilishi',
          setup_change: 'Sozlash / o‘lcham almashtirish',
          yarn_shortage: 'Ip yetishmasligi',
          power_outage: 'Elektr uzilishi',
          no_assignment: 'Operator tayinlanmagan',
          qc_wait: 'Sifat nazoratini kutish',
        },
        start: 'Boshlanish',
        end: 'Tugash',
        duration: 'Davomiylik',
        minutes: '{count} daq',
        reportedBy: 'Xabar bergan',
        loading: 'To‘xtalish hodisalari yuklanmoqda…',
        empty: 'To‘xtalish hodisalari qayd etilmagan.',
        totalDowntime: 'Jami to‘xtalish',
        activeDowntime: 'Faol to‘xtalish',
        noActiveDowntime: 'Faol to‘xtalish hodisalari mavjud emas.',
        ongoing: 'Davom etmoqda',
        openDowntime: 'To‘xtalishni qayd etish',
        close: 'Yopish',
        closeConfirm: 'Ushbu to‘xtalish hodisasini yopish kerakmi?',
        selectReason: 'Sababni tanlang',
        machineId: 'Mashina ID',
        startTime: 'Boshlanish vaqti',
        endTime: 'Tugash vaqti',
        report: 'Qayd etish',
        reporting: 'Qayd etilmoqda…',
        openOnly: 'Faqat faollari',
        reported: '#{id} to‘xtalish qayd etildi',
        closed: '#{id} to‘xtalish yopildi',
      },
      handover: {
        eyebrow: 'Smena boshqaruvi',
        title: 'Smena topshirish',
        description: 'Smena topshirish yozuvlari va nazoratchi izohlari.',
        shift: 'Smena',
        from: 'Dan',
        to: 'Gacha',
        supervisor: 'Nazoratchi',
        notes: 'Izohlar',
        summary: 'Xulosa',
        ordersHandedOver: 'Topshirilgan buyurtmalar',
        issuesFlagged: 'Belgilangan muammolar',
        loading: 'Topshirish yozuvlari yuklanmoqda…',
        empty: 'Tanlangan davr uchun topshirish yozuvlari mavjud emas.',
        attentionRequired: 'E’tibor talab etiladi',
        printSnapshot: 'Xulosani chop etish',
        exportCsv: 'CSV eksport',
        createHandover: 'Smena topshirishni yaratish',
        create: 'Yaratish',
        creating: 'Yaratilmoqda…',
        save: 'Saqlash',
        cancel: 'Bekor qilish',
        created: '#{id} topshirish yaratildi',
      },
      pagination: {
        of: 'dan',
        previous: 'Oldingi',
        next: 'Keyingi',
      },
      state: {
        loading: 'Yuklanmoqda…',
        error: 'Xatolik yuz berdi.',
        retry: 'Qayta urinish',
        noData: 'Ma’lumot mavjud emas.',
      },
    },
  },
  ru: {
    shopfloor: {
      appTitle: 'Производственный цех',
      appDescription: 'Управление сменами, распределение сотрудников и оборудования, выработка, простои и передача смен.',
      nav: {
        shiftDashboard: 'Панель смены',
        activeOrders: 'Активные заказы',
        assignments: 'Назначения',
        hourlyOutput: 'Почасовая выработка',
        downtime: 'Простои',
        handover: 'Передача смены',
        help: 'Помощь',
      },
      help: {
        eyebrow: 'Центр помощи',
        title: 'Помощь',
        subtitle: 'Пошаговые руководства для каждого раздела.',
        back: 'Назад к помощи',
        notFound: 'Статья не найдена.',
        tipsTitle: 'Советы',
      },
      dashboard: {
        eyebrow: 'Управление производством',
        title: 'Панель смены',
        description: 'Текущий статус производства, узкие места и сводка смены.',
        activeOrders: 'Активные заказы',
        ordersCount: '{count} заказов',
        planVsActual: 'План и факт',
        planned: 'План',
        produced: 'Произведено',
        pairs: '{count} пар',
        bottlenecks: 'Узкие места',
        noBottlenecks: 'Узких мест не обнаружено.',
        bottleneckHint: 'Выберите узкое место, чтобы открыть заказ и просмотреть заблокированный этап.',
        stageBlocked: '{stage} заблокирован',
        employeeSummary: 'Сводка по сотрудникам',
        assigned: '{count} назначено',
        machineSummary: 'Сводка по оборудованию',
        running: '{count} работает',
        idle: '{count} простаивает',
        loading: 'Загрузка данных смены…',
        error: 'Не удалось загрузить данные смены.',
        retry: 'Повторить',
        completion: 'Завершение',
        rejectsRework: 'Брак и переработка',
        rejectedPairs: '{count} бракованных пар · {rework} переработка',
        employeeAssignment: 'Назначение сотрудников',
        employeesAssigned: '{count} сотрудников назначено на открытые этапы',
      },
      orders: {
        eyebrow: 'Производственные заказы',
        title: 'Активные заказы',
        description: 'Производственные заказы, находящиеся в исполнении.',
        search: 'Поиск заказов',
        searchPlaceholder: 'Код заказа, продукт или отдел',
        status: 'Статус',
        allStatuses: 'Все статусы',
        inProgress: 'В работе',
        completed: 'Завершён',
        pending: 'Ожидает',
        statuses: {
          planned: 'Запланирован',
          in_progress: 'В работе',
          completed: 'Завершён',
          cancelled: 'Отменён',
        },
        code: 'Заказ',
        product: 'Продукт',
        department: 'Отдел',
        plannedQty: 'План',
        producedQty: 'Произведено',
        progress: 'Прогресс',
        stage: 'Этап',
        actions: 'Действия',
        loading: 'Загрузка заказов…',
        empty: 'Нет заказов, соответствующих фильтрам.',
        viewLots: 'Просмотр партий',
      },
      assignments: {
        eyebrow: 'Распределение ресурсов',
        title: 'Назначения сотрудников и оборудования',
        description: 'Текущие назначения сотрудников и машин на смену.',
        employeeTab: 'Сотрудники',
        machineTab: 'Оборудование',
        employee: 'Сотрудник',
        machine: 'Машина',
        operation: 'Операция',
        order: 'Заказ',
        lot: 'Партия',
        assignedAt: 'Назначено',
        status: 'Статус',
        active: 'Активен',
        loading: 'Загрузка назначений…',
        empty: 'Нет активных назначений на текущую смену.',
        unassigned: 'Не назначен',
        createAssignment: 'Создать назначение',
        create: 'Создать',
        creating: 'Создание…',
        end: 'Завершить',
        endConfirm: 'Завершить это назначение?',
        allShifts: 'Все смены',
        shift: 'Смена',
        day: 'Дневная',
        night: 'Ночная',
        type: 'Тип',
        orderId: 'ID заказа',
        stageCode: 'Код этапа',
        stage: 'Этап',
        selectStage: 'Выберите этап',
        selectEmployee: 'Выберите сотрудника',
        selectMachine: 'Выберите машину',
        noLot: 'Без партии',
        cancel: 'Отмена',
        save: 'Сохранить',
        ended: 'Завершено',
        noEnded: 'Только активные',
      },
      output: {
        eyebrow: 'Учёт выработки',
        title: 'Дневная выработка',
        description: 'Показатели производства по этапам и сотрудникам за выбранную дату.',
        date: 'Дата',
        stage: 'Этап',
        stageCode: 'Код этапа',
        employee: 'Сотрудник',
        allStages: 'Все этапы',
        allEmployees: 'Все сотрудники',
        completed: 'Выполнено',
        rejected: 'Брак',
        rework: 'Переработка',
        unassigned: 'Не назначен',
        exportCsv: 'Экспорт CSV',
        loading: 'Загрузка данных выработки…',
        empty: 'Нет данных о выработке за эту дату.',
        retry: 'Повторить',
      },
      orderDetail: {
        backToOrders: 'К заказам',
        title: 'Производственный заказ',
        planned: 'План',
        produced: 'Произведено',
        totalLots: 'Всего партий',
        activeLots: 'Активных партий',
        completedLots: 'Завершённых партий',
        stageProgress: 'Прогресс этапов',
        cancel: 'Отмена',
        createLot: 'Создать партию',
        creating: 'Создание…',
        startingStage: 'Начальный этап',
        quantity: 'Количество',
        notes: 'Примечания',
        colorVariants: 'Цветовые варианты',
        addColor: 'Добавить цвет',
        removeColor: 'Удалить',
        colorName: 'Цвет',
        colorQuantity: 'Кол-во',
        colorSummary: 'Цвета',
        colorsSumHint: 'Сумма {sum} из {quantity}',
        colorRequired: 'Укажите название цвета и положительное количество в каждой строке.',
        colorSumError: 'Сумма по цветам должна равняться количеству партии.',
        lotCreated: 'Партия {lot} создана.',
        noStages: 'Для этого заказа этапы не настроены.',
        lotQueue: 'Очередь партий',
        lotNumber: 'Номер партии',
        allStatuses: 'Все статусы',
        allStages: 'Все этапы',
        active: 'Активна',
        completed: 'Завершена',
        cancelled: 'Отменена',
        lotStatuses: {
          active: 'Активна',
          completed: 'Завершена',
          cancelled: 'Отменена',
        },
        stageStatuses: {
          pending: 'Ожидает',
          in_progress: 'В работе',
          closed: 'Закрыт',
          completed: 'Завершён',
        },
        noLotsMatch: 'Нет партий, соответствующих фильтрам.',
        lot: 'Партия',
        status: 'Статус',
        currentStage: 'Текущий этап',
        initial: 'Начальное',
        current: 'Текущее',
        created: 'Создано',
        actions: 'Действия',
        progress: 'Прогресс',
        closeStage: 'Закрыть этап',
        recordProgress: 'Записать прогресс',
        stageLabel: 'Этап:',
        completedQty: 'Выполнено',
        rejected: 'Брак',
        rework: 'Переработка',
        employeeId: 'ID сотрудника',
        employee: 'Сотрудник',
        unassigned: 'Не назначен',
        selectEmployeePlaceholder: 'Выберите сотрудника',
        details: 'Подробнее',
        viewEntries: 'Записи',
        reopenStage: 'Переоткрыть',
        closeStageTitle: 'Закрыть этап',
        closeStageHint: 'Закрывает этот этап по всему заказу (все партии).',
        confirm: 'Подтвердить',
        close: 'Закрыть',
        reopenStageTitle: 'Переоткрыть этап',
        reopenHint: 'Переоткрытие требует указания причины и прав руководителя.',
        reopenReason: 'Причина',
        selectReason: 'Выберите причину…',
        reopenReasonText: 'Описание причины',
        reopenRequiresReason: 'Выберите причину и укажите описание.',
        stageClosedAll: 'Этап {stage} закрыт для всех партий.',
        stageReopened: 'Этап {stage} переоткрыт.',
        entriesTitle: 'Записи этапа',
        noEntries: 'Для этого этапа записи не зарегистрированы.',
        entryAction: 'Действие',
        entryDeltas: 'Изменения',
        entryEmployee: 'Сотрудник',
        entryLot: 'Партия',
        entryTime: 'Время',
        entryStage: 'Этап',
        entryTypes: {
          progress: 'Прогресс',
          close: 'Закрытие',
          reopen: 'Переоткрытие',
          create: 'Создание',
        },
        reopenReasons: {
          qc_issue: 'Проблема контроля качества',
          operator_error: 'Ошибка оператора',
          material_issue: 'Проблема с материалом',
          machine_issue: 'Проблема с оборудованием',
          supervisor_decision: 'Решение руководителя',
          other: 'Другое',
        },
        lotDetailsTitle: 'Детали партии',
        lotStages: 'Отслеживание этапов партии',
        lotEntries: 'Активность партии',
        stage: 'Этап',
        save: 'Сохранить',
        selectEmployee: 'Выберите отчитывающегося сотрудника.',
        selectClosingEmployee: 'Выберите сотрудника, закрывающего этап.',
        closeConfirm: 'Закрыть этап {stage} для партии {lot}?',
        progressRecorded: 'Прогресс записан для партии {lot}.',
        stageClosed: 'Этап закрыт для партии {lot}.',
        enterStageQuantity: 'Введите начальный этап и количество больше нуля.',
        loadingOrder: 'Загрузка заказа…',
        pageOf: 'Страница {page} из {total}',
        previous: 'Назад',
        next: 'Вперёд',
      },
      downtime: {
        eyebrow: 'Учёт простоев',
        title: 'События простоя',
        description: 'Зарегистрированные простои с причинами и длительностью.',
        reason: 'Причина',
        machine: 'Машина',
        noMachine: 'Без оборудования',
        selectMachine: 'Выберите оборудование…',
        reasons: {
          machine_breakdown: 'Поломка оборудования',
          setup_change: 'Переналадка / смена размера',
          yarn_shortage: 'Нехватка пряжи',
          power_outage: 'Отключение электроэнергии',
          no_assignment: 'Не назначен оператор',
          qc_wait: 'Ожидание ОТК',
        },
        start: 'Начало',
        end: 'Конец',
        duration: 'Длительность',
        minutes: '{count} мин',
        reportedBy: 'Сообщил',
        loading: 'Загрузка простоев…',
        empty: 'Простои не зарегистрированы.',
        totalDowntime: 'Общий простой',
        activeDowntime: 'Активный простой',
        noActiveDowntime: 'Нет активных простоев.',
        ongoing: 'В процессе',
        openDowntime: 'Зарегистрировать простой',
        close: 'Закрыть',
        closeConfirm: 'Закрыть этот простой?',
        selectReason: 'Выберите причину',
        machineId: 'ID машины',
        startTime: 'Время начала',
        endTime: 'Время окончания',
        report: 'Зарегистрировать',
        reporting: 'Регистрация…',
        openOnly: 'Только открытые',
        reported: 'Простой #{id} зарегистрирован',
        closed: 'Простой #{id} закрыт',
      },
      handover: {
        eyebrow: 'Управление сменами',
        title: 'Передача смены',
        description: 'Записи о передаче смен и примечания руководителя.',
        shift: 'Смена',
        from: 'С',
        to: 'По',
        supervisor: 'Руководитель',
        notes: 'Примечания',
        summary: 'Сводка',
        ordersHandedOver: 'Передано заказов',
        issuesFlagged: 'Отмеченные проблемы',
        loading: 'Загрузка записей передачи смен…',
        empty: 'Нет записей передачи смен за выбранный период.',
        attentionRequired: 'Требуется внимание',
        printSnapshot: 'Печать сводки',
        exportCsv: 'Экспорт CSV',
        createHandover: 'Создать передачу смены',
        create: 'Создать',
        creating: 'Создание…',
        save: 'Сохранить',
        cancel: 'Отмена',
        created: 'Передача смены #{id} создана',
      },
      pagination: {
        of: 'из',
        previous: 'Назад',
        next: 'Вперёд',
      },
      state: {
        loading: 'Загрузка…',
        error: 'Что-то пошло не так.',
        retry: 'Повторить',
        noData: 'Нет данных.',
      },
    },
  },
}
